<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <router-view/> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如 page1,page2 -->
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive">
      <!-- 这里是不被缓存的视图组件，比如 page3 -->
    </router-view>
  </div>
</template>

<script>
  import api from './api/api';
  import router from './router';
  export default {
    name: 'App',
    methods: {},
    created() {
      let that = this;
      let login_time=localStorage.getItem('login_time');
      let now_time=new Date().getTime();
      if(now_time-login_time>=2*60*60*1000){
        localStorage.removeItem('mobile');
      }else{
        localStorage.setItem('login_time',new Date().getTime());
      }

      // setInterval(() => {
      // console.log('-----');
      // console.log(window.performance.memory);
      // }, 1000);
    },
  }
</script>

<style>
  html{
    font-size: 62.5px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue